import { render, staticRenderFns } from "./PeriodIndexByNameColumnTemplate.vue?vue&type=template&id=de020188"
import script from "./PeriodIndexByNameColumnTemplate.vue?vue&type=script&lang=js"
export * from "./PeriodIndexByNameColumnTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports